export class MatchPhoneHelper {
    static regex(): RegExp {
        return /^\+(45\d{8}|49\d{10}|380\d{9})$/;
    }
}
